'use strict';

var React = require('react'),
    Icon = require('./Icon'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

require('./Tag.less');

var Tag = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    content: React.PropTypes.string.isRequired,
    icon: React.PropTypes.string,
    onRemove: React.PropTypes.func
  },

  className: 'Tag',

  render: function () {
    return (
      <span className={this.getClassName()}>
        {this.props.icon &&
          <Icon name={this.props.icon}
                size='xsmall'
                mode={this.props.icon === 'email' ? 'stroke' : 'fill'} />
        }

        <span className='Tag-content'>{this.props.content}</span>

        {this.props.onRemove &&
          <Icon name='cross'
                size='xxsmall'
                mode='stroke'
                onClick={this.props.onRemove} />
        }
      </span>
    );
  }
});

module.exports = Tag;



/** WEBPACK FOOTER **
 ** ./atoms/Tag.jsx
 **/